import React, { useEffect, useState } from "react";
import classNames from "classnames";

import "./Loading.styles.scss";

interface LoadingProps {
  loading: boolean;
  dotsNumber?: number;
  processTitle?: string;
  resultTitle?: string;
  titleStyles?: React.CSSProperties;
}

type ProcessStatus = "stable" | "showLoading" | "hideLoading" | "showCompleted" | "hideCompleted";

export const Loading: React.FC<LoadingProps> = ({
  loading,
  dotsNumber = 4,
  processTitle = "loading",
  resultTitle = "completed",
  titleStyles
}) => {
  const [processStatus, setProcessStatus] = useState<ProcessStatus>("stable");

  useEffect(() => {
    if (loading) {
      setProcessStatus("showLoading");
    }

    if (processStatus === "showLoading" && !loading) {
      setProcessStatus("hideLoading");
    }
  }, [loading]);

  return (
    <div className="loading">
      <div
        onAnimationEnd={() => {
          if (processStatus === "hideLoading") {
            setProcessStatus("showCompleted");
          }
        }}
        className={classNames("loading__process", "process", {
          "process--active": processStatus === "showLoading",
          "process--off": processStatus === "hideLoading"
        })}
      >
        <p className="process__title" style={titleStyles}>
          {processTitle}
        </p>
        <div className="process__items">
          {new Array(dotsNumber).fill("").map((_, key) => (
            <div key={key} className="process__item" />
          ))}
        </div>
      </div>
      <div
        onAnimationEnd={() => {
          if (processStatus === "showCompleted") {
            setProcessStatus("hideCompleted");
          }
          if (processStatus === "hideCompleted") {
            setProcessStatus("stable");
          }
        }}
        className={classNames("loading__result", "result", {
          "result--active": processStatus === "showCompleted",
          "process--off": processStatus === "hideCompleted"
        })}
      >
        {resultTitle}
      </div>
    </div>
  );
};
